const CART_PREFIX = "bookish-author-cart:";

const getCartKey = () => {
  return `${CART_PREFIX}${window.location.hostname.toLowerCase()}`;
};

export const getAuthorCart = () => {
  try {
    const stored = localStorage.getItem(getCartKey());
    const parsed = stored ? JSON.parse(stored) : [];

    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.error("Failed reading author cart:", err);
    return [];
  }
};

export const saveAuthorCart = (items = []) => {
  try {
    localStorage.setItem(getCartKey(), JSON.stringify(items));

    window.dispatchEvent(
      new CustomEvent("bookish-cart-updated", {
        detail: { items },
      })
    );

    return items;
  } catch (err) {
    console.error("Failed saving author cart:", err);
    return items;
  }
};

export const addToAuthorCart = (item) => {
  const cart = getAuthorCart();

  const existingIndex = cart.findIndex(
    (cartItem) => cartItem.cartItemId === item.cartItemId
  );

  if (existingIndex >= 0) {
    const existing = cart[existingIndex];

    cart[existingIndex] = {
      ...existing,
      quantity: Number(existing.quantity || 1) + Number(item.quantity || 1),
    };
  } else {
    cart.push({ ...item, cartRevision: crypto.randomUUID() });
  }

  return saveAuthorCart(cart);
};

export const removeFromAuthorCart = (cartItemId) => {
  const cart = getAuthorCart().filter(
    (item) => item.cartItemId !== cartItemId
  );

  return saveAuthorCart(cart);
};

export const updateAuthorCartQuantity = (cartItemId, quantity) => {
  const nextQuantity = Math.max(1, Number(quantity || 1));

  const cart = getAuthorCart().map((item) =>
    item.cartItemId === cartItemId
      ? {
          ...item,
          quantity: nextQuantity,
        }
      : item
  );

  return saveAuthorCart(cart);
};

export const clearAuthorCart = () => {
  return saveAuthorCart([]);
};

export const getAuthorCartCount = () => {
  return getAuthorCart().reduce(
    (total, item) => total + Number(item.quantity || 1),
    0
  );
};
